import { render, staticRenderFns } from "./enterprise-risk-scan-cn-full.vue?vue&type=template&id=b34caf1e&"
import script from "./enterprise-risk-scan-cn-full.vue?vue&type=script&lang=js&"
export * from "./enterprise-risk-scan-cn-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports